
import { defineComponent } from 'vue';
import Modal from '@/shared/mixins/Modal';
import AdDetail from './AdDetail.vue';

export default defineComponent({
  name: 'AdPreview',
  mixins: [Modal],
  emits: ['close'],
  components: {
    AdDetail,
  },
  props: {
    adFrontId: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
